(() => {
  const prefix = 'lip-breadcrumb:';
  const normalize = (path) => path.replace(/\/$/, '');
  const productPath = (url) => {
    const match = url.pathname.match(/^(.*)\/products\/([^/]+)\/?$/);
    if (!match) return null;
    const locale = match[1].split('/collections/')[0];
    return normalize(locale + '/products/' + match[2]);
  };
  const collectionPath = (url) => {
    const match = url.pathname.match(/^(.*\/collections\/[^/]+)(?:\/[^/]+)?\/?$/);
    return match ? normalize(match[1]) : null;
  };
  document.querySelectorAll('[data-product-breadcrumb]').forEach((item) => {
    try {
      const choices = JSON.parse(item.dataset.collectionChoices);
      const key = prefix + normalize(item.dataset.productPath);
      let saved = null;
      try {
        saved = JSON.parse(sessionStorage.getItem(key));
        sessionStorage.removeItem(key);
      } catch (_) {}
      let source = null;
      if (saved && Date.now() - saved.time >= 0 && Date.now() - saved.time < 120000 && saved.origin === location.origin) {
        source = saved.collection;
      }
      if (!source && document.referrer) {
        const referrer = new URL(document.referrer);
        if (referrer.origin === location.origin) source = collectionPath(referrer);
      }
      const chosen = choices.find((choice) => normalize(new URL(choice.url, location.origin).pathname) === source);
      if (!chosen) return;
      const link = item.querySelector('a');
      link.setAttribute('href', chosen.url);
      link.textContent = chosen.title;
      item.hidden = false;
      item.style.removeProperty('display');
    } catch (_) {
      // The primary collection remains available without browser context.
    }
  });
  const rememberCollection = (event) => {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;
    try {
      const target = new URL(anchor.href, location.href);
      if (target.origin !== location.origin) return;
      const path = productPath(target);
      if (!path) return;
      const card = anchor.closest('[data-breadcrumb-collection-url]');
      const source = card ? new URL(card.dataset.breadcrumbCollectionUrl, location.origin) : new URL(location.href);
      const collection = source.origin === location.origin ? collectionPath(source) : null;
      const key = prefix + path;
      if (!collection) {
        sessionStorage.removeItem(key);
        return;
      }
      sessionStorage.setItem(key, JSON.stringify({collection, origin: location.origin, time: Date.now()}));
    } catch (_) {}
  };
  document.addEventListener('click', rememberCollection, true);
  document.addEventListener('auxclick', rememberCollection, true);
})();
